import * as React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { PropertyDetailsCard } from "../PropertyDetailsCard";

const DesktopHeader = ({ applicant, isDesktop, action }) => {
    return (
        <Card
            sx={{
                padding: "20px",
                background: "white",
                display: "flex",
                alignItems: "center",
                borderRadius: "12px",
                width: "100%",
            }}>
            <CardContent sx={{ width: "100%" }}>
                <Grid container justifyContent={"space-between"} alignItems={"center"}>
                    <Grid item sx={{ color: "#164C63" }}>
                        <Typography variant="h4" style={{ fontSize: isDesktop ? "2rem" : "1.5rem" }}>
                            <span style={{ fontWeight: "300" }}>Hello,</span>{" "}
                            {applicant?.contact?.firstName
                                ? applicant.contact?.firstName
                                : applicant?.contact?.lastName
                                ? applicant?.contact?.lastName
                                : applicant?.firstName
                                ? applicant?.firstName
                                : applicant?.lastName}
                            !
                        </Typography>
                        <Typography variant="h6">
                            Not you? <a href="/signout">Sign out</a>
                        </Typography>
                    </Grid>
                    {!action ? (
                        <Box>
                            {applicant?.application?.applicationListingId && (
                                <Box
                                    sx={{
                                        border: "1px solid #ececec",
                                        padding: "8px",
                                        borderRadius: "5px",
                                        minHeight: "100px",
                                        background: "#fffdf9",
                                        mt: isDesktop ? "0px" : "1rem",
                                    }}>
                                    <PropertyDetailsCard item={applicant.application}></PropertyDetailsCard>
                                </Box>
                            )}
                        </Box>
                    ) : (
                        <Box sx={isDesktop ? {} : { width: "100%", marginTop: "2rem" }}>{action}</Box>
                    )}
                </Grid>
            </CardContent>
        </Card>
    );
};

export { DesktopHeader };
